export const getPaidness = (eventType) => {
  if (!eventType) return 'Other'
  if (eventType.endsWith('P')) return 'Paid'
  if (eventType.endsWith('U')) return 'Unpaid'
  return 'Other'
}

export const parseFinagoEventTypeId = (newValue) => {
  if (newValue == null) return null
  return Number(newValue)
}

export const getHrEventTypeCode = (eventTypeId, mappings) => {
  if (eventTypeId == null || !Array.isArray(mappings)) return ''
  const match = mappings.find((m) => String(m.finagoEventTypeId) === String(eventTypeId))
  return match?.eventType ?? ''
}